.wrapper {
  position: relative;
  padding-top: 100px;
  padding-bottom: 130px;
  background-image: url(https://static.digisthesia.com/hexploit/images/bg.webp);
  background-size: cover;
  background-position: center;

  @media (max-width: $mantine-breakpoint-xs) {
    padding-top: 80px;
    padding-bottom: 50px;
  }
}

.inner {
  position: relative;
  z-index: 1;
}

.title {
  font-weight: 800;
  font-size: 40px;
  letter-spacing: -1px;
  padding-left: var(--mantine-spacing-md);
  padding-right: var(--mantine-spacing-md);
  color: var(--mantine-color-white);
  margin-bottom: var(--mantine-spacing-xs);
  text-align: center;
  font-family: Outfit, var(--mantine-font-family);

  @media (max-width: $mantine-breakpoint-xs) {
    font-size: 28px;
    text-align: left;
  }
}

.highlight {
  color: var(--mantine-color-primary-4);
}

.description {
  color: var(--mantine-color-gray-0);
  text-align: center;
  background-color: #231b4589;
  border-radius: 20px;
  padding: 1rem;
  backdrop-filter: blur(5px);

  @media (max-width: $mantine-breakpoint-xs) {
    font-size: var(--mantine-font-size-md);
    text-align: left;
  }
}

.controls {
  margin-top: calc(var(--mantine-spacing-xl) * 1.5);
  display: flex;
  justify-content: center;
  padding-left: var(--mantine-spacing-md);
  padding-right: var(--mantine-spacing-md);

  @media (max-width: $mantine-breakpoint-xs) {
    flex-direction: column;
  }
}
